module.exports = __webpack_public_path__ + "static/kenny-abef3e8782e14bafb7f68fd559ccff08.png";